<template>
  <a-modal width="55%" title="修改" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-row :gutter="[24, 8]">
        <a-col :span="12">
          <a-form-item label="期望职位" name="jobTitleExpectation">
            <DictSelect v-model:value="form.jobTitleExpectation" :dict-name="education.HOPE_JOB" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="期望城市" name="prov">
            <city-select-all v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
              placeholder="请选择省/市/区" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="期望薪资" name="salaryExpectation">
            <DictSelect v-model:value="form.salaryExpectation" :dict-name="education.SALARY" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="期望从事行业" name="businessExpectation">
            <DictSelect v-model:value="form.businessExpectation" :dict-name="education.RESEARCH_FIELD"
              placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="入职时间" name="estimatedTimeEntry">
            <DatePicker style="width: 100%" v-model:value="form.estimatedTimeEntry" :format="dateFormat.DATE_DAY"
              :showTime="false" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="工作性质" name="natureWork">
            <DictSelect v-model:value="form.natureWork" :dict-name="education.WORK_TYPE" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="目前工作状态" name="stateWork">
            <DictSelect v-model:value="form.stateWork" :dict-name="education.WORK_STATUS" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="期望展示效果" name="displayEffect">
            <DictSelect v-model:value="form.displayEffect" :dict-name="education.HOPE_SHOW" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="自我评价" name="selfEvaluation">
            <a-textarea v-model:value="form.selfEvaluation" placeholder="请输入" :auto-size="{ minRows: 4, maxRows: 6 }" />
          </a-form-item>
        </a-col>
      </a-row>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { employmentIntentionInfo } from "@/api/educationService";
import DictSelect from "@/components/other/DictSelect";
import CitySelectAll from "@/components/form/select/AllCitySelect";
import DatePicker from "@/components/form/datePicker/DatePicker";
import { education, dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: { DictSelect, DatePicker, CitySelectAll },
  mixins: [formMixin],
  data() {
    return {
      education,
      dateFormat,
      form: {
        id: null,
      },
      rules: {
        jobTitleExpectation: [dataCheck.required({})],
        prov: [],
        city: [],
        dist: [],
        salaryExpectation: [dataCheck.required({})],
        stateWork: [dataCheck.required({})],
        estimatedTimeEntry: [dataCheck.required({})],
        natureWork: [dataCheck.required({})],
        businessExpectation: [dataCheck.required({})],
        displayEffect: [dataCheck.required({})],
        selfEvaluation: [],
        id: [],
      },
      submitUrl: employmentIntentionInfo.saveupdate
    }
  },
}
</script>
<style scoped lang="less"></style>
